var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showButton)?_c('div',{staticClass:"back-to-top",on:{"click":_vm.scrollToTop}},[_c('img',{attrs:{"src":"/assets/img/Main/goBlot.png"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }